module.exports = __webpack_public_path__ + "static/cross-c830043544da9750e0012110e9a40036.jpg";